import { gql } from '@apollo/client';

export default gql`
  fragment Group on Group {
    _id
    name
  }
`;
